import { render, staticRenderFns } from "./relatorioDevolucao.vue?vue&type=template&id=0fc41ca8"
import script from "./relatorioDevolucao.vue?vue&type=script&lang=js"
export * from "./relatorioDevolucao.vue?vue&type=script&lang=js"
import style0 from "./relatorioDevolucao.vue?vue&type=style&index=0&id=0fc41ca8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports